import { render, staticRenderFns } from "./InventoryLostTitleAction.vue?vue&type=template&id=3671ba01&scoped=true"
import script from "./InventoryLostTitleAction.vue?vue&type=script&lang=js"
export * from "./InventoryLostTitleAction.vue?vue&type=script&lang=js"
import "./InventoryLostTitleAction.vue?vue&type=style&index=0&id=3671ba01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671ba01",
  null
  
)

export default component.exports